export default {
  "import_notification_success_title": "Import Completed",
  "import_notification_failed_title": "Import Failed", 
  "import_notification_error_title": "Import Error",
  "import_notification_message": "Transaction of type {importType} has finished processing with status: {status}. Click here for more details.",
  "import_notification_parse_error": "Failed to process import notification"
};
